import { RootState } from "@/app/stores"
import { broadcast } from "@/shared/api/notifications/notifications"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"
import { IBroadcastRequest } from "@/shared/api/notifications/types"

interface IUserBroadcastRequest {
    image: File | null
    message: string
}

export const fetchUserBroadcast = createAsyncThunk<
    void,
    IUserBroadcastRequest,
    { state: RootState }
>('userBroadcast/fetchUserBroadcast', async(data, thunkAPI) => {
    try {
        const { currentUser } = thunkAPI.getState().userBroadcast
        
        const formData = new FormData()
        if (data.image) {
            formData.append('image', data.image)
        }
        formData.append('message', data.message)
        formData.append('userId[]', currentUser.id)

        await broadcast(formData as unknown as IBroadcastRequest)
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message || knownError.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

